import { memo } from "react";

const JobTable = ({ jobs = [] }) => {
    if (!jobs.length) {
        return (
            <ul className="list-group">
                <li className="list-group-item border-0 d-flex p-4 bg-gray-100 border-radius-lg">
                    <div className="d-flex flex-column">
                        <h6 className="text-sm">N/A</h6>
                    </div>
                </li>
            </ul>
        );
    }

    return (
        <ul className="list-group">
            {jobs.map((job) => {
                const {
                    job_id,
                    job_postcode,
                    job_is_pay_ftm,
                    ftm,
                    customer,
                    sub_skill,
                } = job;

                return (
                    <li
                        key={job_id}
                        className="list-group-item border-0 d-flex p-4 mb-2 bg-gray-100 border-radius-lg"
                    >
                        <div className="d-flex flex-column">
                            <h6 className="mb-3 text-sm">
                                #{job_id} - {ftm?.ftm_forename} {ftm?.ftm_surname}
                            </h6>

                            <span className="mb-2 text-xs">
                                Customer Name:
                                <span className="text-dark font-weight-bold ms-sm-2">
                                    {customer?.customer_full_name || "N/A"}
                                </span>
                            </span>

                            <span className="mb-2 text-xs">
                                Postcode:
                                <span className="text-dark ms-sm-2 font-weight-bold">
                                    {job_postcode || "N/A"}
                                </span>
                            </span>

                            <span className="mb-2 text-xs">
                                Job Type:
                                <span className="text-dark ms-sm-2 font-weight-bold">
                                    {sub_skill?.skill?.skill_name} - {sub_skill?.sub_skill_name}
                                </span>
                            </span>

                            <span className="text-xs">
                                Payment:
                                <span className="ms-sm-2">
                                    <span
                                        className={`badge badge-sm ${
                                            job_is_pay_ftm === 1
                                                ? "bg-gradient-success"
                                                : "bg-gradient-dark"
                                        }`}
                                    >
                                        {job_is_pay_ftm === 1 ? "PAY" : "NOT PAY"}
                                    </span>
                                </span>
                            </span>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

export default memo(JobTable);